import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-family-document-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsFamilyDocumentTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consFamilyDocumentTypeEntity = useAppSelector(state => state.consFamilyDocumentType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consFamilyDocumentTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.detail.title">ConsFamilyDocumentType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.code">Code</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.nameEn}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consFamilyDocumentType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consFamilyDocumentTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-family-document-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-family-document-type/${consFamilyDocumentTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsFamilyDocumentTypeDetail;
